<template>
    <div>
        <!--盘点历史-->
        <header class="form-title">
            <Row>
                <Col span="22">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="单号">
                            <Input type="text" class="form-input" v-model.trim="code" style="width: 200px" ></Input>
                            <Button type="primary" style="margin-left: 15px" @click="getSetpointList(valuedate[0],valuedate[1],page.page,page.rows)">搜索</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <section>
            <Alert v-if="pageData==''" align="center">暂无数据</Alert>
            <Card class="historyItem" :dis-hover="false" v-for="(item, index) in pageData" :key="index" @click.native="$router.push({path:'/addInvhistDetail',query:{id:item.id}})">
                <p slot="title"  >{{item.adminName}}</p>
                <span slot="extra" class="typeitem typeitems" v-if="item.number>=0">盘盈</span>
                <span slot="extra" class="typeitem " v-else>盘亏</span>
                <ul class="type-content">
                    <li>  盘点数量：{{item.quantity}} </li>
                    <li>  店铺名：{{shopname}} </li>
                    <li>  单号：{{item.code}} </li>
                    <li>  建立时间：{{item.time}} </li>
                </ul>
            </Card>
        </section>
        <div class="pageTotal"   v-if="pageData!=''">
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                code:'',
                shopname:JSON.parse(localStorage.getItem('shop')).name,
                pageData:{},
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                sendData:{
                    code:'',
                },
                page:{
                    total:0,
                    page:1,
                    rows:12
                }
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(-30)
            this.valuedate[1] = this.nowTime
            this.getSetpointList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            //this.getShopId()
        },
        watch: {
            'code': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getSetpointList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
                }
            },
        },
        methods: {
            //获取盘点列表
            getSetpointList(startTime,endTime,page,rows){
                this.$Api.getSetpointList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime:endTime,
                    code: this.code,
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        res.data.forEach(item=>{
                            item.number=0
                            item.sGoods.forEach(m=>{
                                m.sItems.forEach(k=>{
                                    item.number+=k.quantity
                                })
                            })

                        })

                        this.pageData=res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            // getShopId(){
            //     this.$Api.getShopId({
            //         id:this.cid
            //     }).then(res => {
            //         if(res.code==200){
            //              this.shopname = res.data.name
            //         }else {
            //             this.$Message.warning(res.msg);
            //         }
            //     });
            // },
            modifyTime(time){
                this.valuedate[0]=time[0]
                this.valuedate[1]=time[1]
                this.getSetpointList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            onGongPageTotal(num){
                this.getSetpointList(this.valuedate[0],this.valuedate[1],num,this.page.rows)
            },

        }
    };
</script>

<style lang="scss" scoped>
    .form-title{


        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .historyItem{
        width: 450px;
        height: 190px;
        background-color: #ffffff;
        box-shadow: 0px 3px 10px 0px
        rgba(24, 54, 129, 0.14);
        border-radius: 10px;
        display: inline-block;
        margin: 14px;
        cursor: pointer;
        position: relative;
        .yiche{
            position: absolute;
            right: 20px;
            bottom: 20px;
        }
        .typeitem{
            display: block;
            width: 60px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background-color: #e5fff7;
            border-radius: 4px;
            border: solid 1px #46bab2;
            position: relative;
            top: -3px;
            right: -3px;
            color: #46bab2;
        }
        .type-content{
            li{
                height: 30px;
            }
        }
        .typeitems{
            background-color: #fff2e5;
            border: solid 1px #ffaf5e;
            color: #ffaf5e;
        }
    }
</style>